import classes from "../classes";
import { isActive, getFilterGroups, getFilterQuery } from "../tournament-filters";
import { Link } from "react-router-dom";
import PredefinedBadge from "./predefined-badge";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function SideFilters({ list, location, races, tags, tokenTypes, tournaments }) {
  var tag = tags.valueSeq().find(t => t.get("name") === list);
  var groups = getFilterGroups(tournaments, races, tag)
    .filter(group => !group.onlyShowOnTag || (tag && tag.get("allow_completed")))
    .map(group => (
      <FilterGroup
        group={group}
        key={group.key}
        location={location}
        name={group.name}
        tokenTypes={tokenTypes}
        tournaments={tournaments} />
    ));
  return (
    <div className="filters_drawer">
      {groups}
    </div>
  );
});

var FilterGroup = pure(function FilterGroup({ group, location, name, tokenTypes, tournaments }) {
  if (!group.filters) {
    return null;
  }
  var items = group.filters.map(filter => {
    var matches = 0;
    if (filter.fn) {
      matches = tournaments.filter(t => filter.fn(t, tokenTypes)).count();
      if (matches === 0 && !filter.alwaysShow) {
        return null;
      }
    }
    return (
      <li key={filter.key}>
        <FilterOption filter={filter} location={location} number={matches} />
      </li>
    );
  });
  return (
    <div className="filters_group">
      <label>
        {"Filter by " + name}
      </label>

      <ul className="filters_facet-list">
        {items}
      </ul>
    </div>
  );
});

var FilterOption = pure(function FilterOption({ filter, location, number }) {
  var badgeElem;
  if (filter.badge) {
    badgeElem = <PredefinedBadge type={filter.badge} />;
  }
  var numberLabel;
  if (number > 0) {
    numberLabel = (
      <span className="facet_badge badge badge--number badge--ghost">
        {number}
      </span>
    );
  }

  var linkTo = {
    pathname: location.pathname,
    search: getFilterQuery(filter, location)
  };

  return (
    <Link
      className={classes({
        "filters_facet": true,
        "filters_facet--is-active": isActive(filter, location)
      })}
      to={linkTo}>
      <span className="filters_facet-label">
        {badgeElem}

        <span>
          {filter.name}
        </span>
      </span>

      {numberLabel}
    </Link>
  );
});
